module.exports = __webpack_public_path__ + "309f9e0ecf724c415138f14888a623d6.svg";